import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastService } from '../../_services/toast.service';

import { DevisService } from '../../_services/devis.service';
import { DevisFilesService } from "../../_services/devis-files.service";
import { SecurityService } from '../../_services/security.service';
import { IMyDpOptions } from "mydatepicker";

import { debounceTime } from 'rxjs/operators';

declare var jQuery: any;
import '../../../assets/semantic/semantic.min.js';

@Component({
  selector: 'app-devis',
  templateUrl: './devis.component.html',
  styleUrls: ['./devis.component.css']
})
  
export class DevisComponent implements OnInit {

  @Output() updateDevisFiles: EventEmitter<object> = new EventEmitter<object>();
  
  devisForm: FormGroup;
  devisAnswerForm: FormGroup;
  filtersForm: FormGroup;

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "dd/mm/yyyy",
    openSelectorOnInputClick: true,
    editableDateField: false,
  };

  validated_devis: any[] = [];
  non_validated_devis: any[] = [];

  selectedFile: File = null;
  temporaryFiles: { file: File, title: string }[] = [];
  addDevisFileLoading: boolean = false;
  isAdmin: boolean = false
  selectedDevisId: number;
  existingFileName: string = null;

  constructor(
    private fb: FormBuilder,
    private devisService: DevisService,
    private devisFilesService: DevisFilesService,
    private router: Router,
    private toast: ToastService,
    private securityService: SecurityService) { }

  ngOnInit() {

    this.devisForm = this.fb.group({
      company: [{ value: '', disable: true }],
      departure_id: ['', Validators.required],
      arrival_id: ['', Validators.required],
      vehicleType: ['', Validators.required],
      quantity: ['', Validators.required],
      departure_date: new FormControl(),
      arrival_date: new FormControl(),
      observations: [''],
      loading_hour: new FormControl(),
      loading_contact: new FormControl(),
      shipping_hour: new FormControl(),
      shipping_contact: new FormControl(),
      hayon: new FormControl(),
      accessible: new FormControl(),
      file: new FormControl,
      file_title: new FormControl()
    })

    this.devisAnswerForm = this.fb.group({
      devisAnswer: new FormControl('', Validators.required),

    })

    this.filtersForm = this.fb.group({
      client_id: new FormControl(),
      departure_id: new FormControl(),
      arrival_id: new FormControl(),
      departure_date: new FormControl(),
      arrival_date: new FormControl(),
    });

    this.securityService.isAdmin().then(
      (isAdmin:boolean) => {
        this.isAdmin = isAdmin;
      },
      (error) => {
        console.error('Erreur lors de la vérification du rôle admin', error);
      }
    );

    this.filtersForm.valueChanges.pipe(debounceTime(500)).subscribe((value) => {
      
      this.loadDevis(value);
    })

    //this.devisForm.patchValue({ company: 'Company name' }); //company connected
    
    this.loadDevis();
  }

  
  async openModal(idModal: string, devisId: number = 0, action: 'ADD' | 'EDIT' | 'RESPONSE' = 'ADD'): Promise<void> {
    if (devisId) {
      this.selectedDevisId = devisId;
      
      try {
        const devis = await this.devisService.getDevisById(devisId).toPromise();
        if (devis.devis_filename) {
          this.existingFileName = devis.devis_filename;
        }
        if (devis.answer) {
          this.devisAnswerForm.patchValue({
            devisAnswer: devis.answer
          });
        }
        if (action === 'EDIT') {
          this.devisForm.reset();
          this.devisForm.patchValue({
            company: devis.company,
            departure_id: devis.departure_id,
            arrival_id: devis.arrival_id,
            vehicleType: devis.vehicle,
            quantity: devis.quantity,
            departure_date:  devis.departure_date,
            arrival_date:  devis.arrival_date ,
            observations: devis.observations,
            loading_hour: devis.loading_hour,
            loading_contact: devis.loading_contact,
            shipping_hour: devis.shipping_hour,
            shipping_contact: devis.shipping_contact,
            hayon: devis.hayon,
            accessible: devis.accessible,
          }); 
        }
        jQuery(`#${idModal}`).modal({ inverted: true }).modal('show');
      } catch (error) {
        console.error('Error getting devis', error)
      }
    } else {
      this.devisForm.reset();
      jQuery(`#${idModal}`).modal({ inverted: true }).modal('show');
    }
  }

  onFileSelected(event): void {
    this.selectedFile = <File>event.target.files[0];
  }

  onDevisAnswerFileSelected(event): void {
    this.selectedFile = <File>event.target.files[0];
  }

  submitDevisForm(): void {
    if (this.devisForm.valid) {
      let formData = this.devisForm.value;

      formData.departure_date = formData.departure_date ? formData.departure_date : null;
      formData.arrival_date = formData.arrival_date ? formData.arrival_date : null;

      if (this.selectedDevisId) {
        this.devisService.updateDevis(this.selectedDevisId, formData).subscribe(
          (response) => {
            this.uploadDevisFiles(response.id);
            this.toast.success('Devis mis à jour', false, 'Mise à jour de devis');
            this.loadDevis();
            jQuery('#add-devis-modal').modal('hide');
          },
          (error) => {
            this.toast.error('Une erreur est survenue lors de la mise à jour du devis', false, 'Mise à jour de devis');
            console.log(error);
          }
        );
      } else {
        this.devisService.createDevis(this.devisForm.value).subscribe(
          (response) => {
            this.uploadDevisFiles(response.id)
            this.toast.success('Devis créé', false, 'Création de devis');
          
            this.loadDevis();
            jQuery('#add-devis-modal').modal('hide');
          },
          (error) => {
            this.toast.error('Une erreur est survenue lors de la création du devis', false, 'Création de devis');
            console.log(error);
          }
        );
      }
    } else {
      this.markFormGroupTouched(this.devisForm);

      // Facultatif : logguer les erreurs dans la console pour plus de détails
    Object.keys(this.devisForm.controls).forEach(key => {
      const controlErrors = this.devisForm.get(key).errors;
      if (controlErrors != null) {
        console.log('Erreur dans le champ:', key, controlErrors);
      }
    });

       this.toast.error('Le formulaire contient des erreurs, veuillez vérifier les champs.', false, 'Validation du formulaire');
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }
  
  handleDevisFileInput(files: FileList) {
    if (files.length > 0) {
      this.selectedFile = files.item(0);
    }
  }
  
  resetDevisFileData() {
    this.devisForm.get('files').reset();
  }

  removeFile(index: number) {
    this.temporaryFiles.splice(index, 1);
  }

  addDevisFile() {
    const titleControl = this.devisForm.get('file_title');
    const title = titleControl.value;
    
    if (!this.selectedFile) {
      this.toast.error("Veuillez sélectionner un fichier.", false, "Ajout d'un document");
      return;
    }

    if (!title || !title.trim().length) {
      this.toast.error("Veuillez saisir un titre pour le document.", false, "Ajout d'un document");
      return
    }

    this.temporaryFiles.push({ file: this.selectedFile, title });
    this.selectedFile = null;
    titleControl.reset();
  }

  uploadDevisFiles(devisId: string) {
    this.addDevisFileLoading = true;
    const files = this.temporaryFiles

    files.forEach(fileData => {
      const formData = new FormData();
      formData.append('devis_id', devisId)
      formData.append('planning_file_title', fileData.title);
      formData.append('file', fileData.file);

      this.devisFilesService.addDevisFile(formData).subscribe(
        (response) => {
          this.toast.success(`Le document '${fileData.title}' a été ajouté avec succès`, false, "Ajout d'un document");
          this.updateDevisFiles.emit({ planning_file: response, isDeleted: false });
        },
        (error) => {
          console.error('Error uploading file', error);
          this.toast.error(`Une erreur est survenue lors de l'ajout du document '${fileData.title}'.`, false);
        }
      );
    });

    this.addDevisFileLoading = false;
    this.temporaryFiles = [];
  }

  loadDevis(params?): void {
    this.devisService.getDevis(params).subscribe(
      (response) => {

        this.validated_devis = response.validated_devis;
        this.non_validated_devis = response.non_validated_devis;
      },
      (error) => {
        console.error('Erreur lors de la récupération des demandes de devis', error);
      }
    );
  }

  createDemande(devis) {
    this.devisService.createDemande(devis).subscribe((response) => {
      this.loadDevis()
    }, (error) => { 
      console.log(error)
    })
  }

  closeDevisAnswerModal() {
    this.selectedFile = null;
    this.devisAnswerForm.reset();
    jQuery('#answer-devis-modal').modal('hide');
  }

  //submitAnswerDevisForm
  submitAnswerDevisForm() {
    const formData = new FormData();
    
    formData.append('devisAnswer', this.devisAnswerForm.get('devisAnswer').value);
    
    if (this.selectedFile) {
      formData.append('file', this.selectedFile, this.selectedFile.name);
    }

    this.devisService.answerDevis(this.selectedDevisId, formData).subscribe((response) => {
      this.closeDevisAnswerModal()
      this.loadDevis()
    }, (error) => { 
      console.log(error)
    })
  }

  openDevisFile(single) {
    this.devisService.download(single.devis_filename).subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    });

  }

  removeSelectedFile() {
    this.selectedFile = null;
    this.existingFileName = null;
    //delete file fron backend
    this.devisService.deleteDevisFile(this.selectedDevisId).subscribe((response) => {
      console.log(response)
    }, (error) => {
      console.log(error)
    })
  }

  recommendDevis(devis): void {
    // Réinitialiser selectedDevisId pour forcer la création d'un nouveau devis
    this.selectedDevisId = null;
    // Pré-remplir le formulaire avec les informations du devis validé
    this.devisForm.patchValue({
      company: devis.company,
      departure_id: devis.departure_id,
      arrival_id: devis.arrival_id,
      vehicleType: devis.vehicle,
      quantity: devis.quantity,
      departure_date: devis.departure_date, 
      arrival_date: devis.arrival_date,
      observations: devis.observations,
      loading_hour: devis.loading_hour,
      shipping_hour: devis.shipping_hour,
      loading_contact: devis.loading_contact,
      shipping_contact: devis.shipping_contact,
      hayon: devis.hayon,
      accessible: devis.accessible,
      file: null // Pas de fichier pour le recommander comme un nouveau devis
    });

    // Ouvrir la modal avec les informations pré-remplies
    jQuery('#add-devis-modal').modal({ inverted: true }).modal('show');
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/devis/devis.component.ts